import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getPeriods({ commit }, data) {
      try {
        const response = await api.get('/periods')
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
